<template>
  <div class="labels-page">
    <div>
      <h1 class="h4 primary--text">
        {{ $t('views.label_printing.label_printing') }}
      </h1>
    </div>
    <main>
      <v-row>
        <v-col
          cols="6"
        >
          <div class="step px-10 py-6 white">
            <h2 class="h4 primary--text">
              {{ $t('views.label_printing.step1') }}
            </h2>
            <!-- <div class="input-block input-block_white">
              <label class="input-block__label">
                {{ $t('views.label_template.select_template') }}
              </label>
              <v-autocomplete
                v-model="labelType"
                :loading="loading"
                :disabled="loading"
                :items="labelTemplates"
                :search-input.sync="templateListSearch"
                :placeholder="$t('common.type_to_search')"
                hide-no-data
                solo
              />
            </div> -->
            <h3 class="h5 step__top__description">
              {{ $t('views.label_printing.upload_data') }}
            </h3>

            <div class="mt-10">
              <!-- eslint-disable max-len -->
              <button
                :disabled="loading"
                class="btn spso-button spso-button_line spso-button_lowercase step_first__buttons__button step_first__buttons__button_download mr-5"
                @click="downloadTemplate()"
              >
                <v-icon>mdi-download</v-icon>
                {{ $t('views.label_printing.download_template') }}
              </button>
              <!-- eslint-enable max-len -->
              <a
                v-if="template"
                v-show="false"
                ref="template"
                :href="template"
                download="asn-template.xlsx"
              />
              <!-- eslint-disable max-len -->
              <button
                :disabled="loading"
                class="btn spso-button spso-button_line spso-button_lowercase step_first__buttons__button"
                @click="selectFile()"
              >
                <v-icon>mdi-upload</v-icon>
                {{ $t('common.upload') }}
              </button>
              <!-- eslint-enable max-len -->
              <input
                v-show="false"
                ref="file"
                type="file"
                accept=".xlsx"
                @change="setFile()"
              >
            </div>

            <div class="step_first__selected">
              <span v-if="file">
                <span class="step_first__selected-label">
                  {{ $t('views.label_printing.selected_file') }}
                </span>
                <span class="step_first__selected-file">{{ file.name }}</span>
              </span>
            </div>
          </div>
        </v-col>

        <v-col
          cols="6"
          class="pr-0"
        >
          <div class="step px-10 py-6 white">
            <h2 class="h4 primary--text">
              {{ $t('views.label_printing.step2') }}
            </h2>
            <h3 class="h5 step__top__description">
              {{ $t('views.label_printing.print') }}
            </h3>

            <div class="mt-10">
              <!-- eslint-disable max-len -->
              <button
                :disabled="loading"
                class="btn spso-button spso-button_line spso-button_lowercase step_second__buttons__button"
                @click="createLabels()"
              >
                {{ $t('views.label_printing.create_labels') }}
              </button>
              <!-- eslint-enable max-len -->
              <a
                v-if="pdf"
                v-show="false"
                ref="pdf"
                :href="pdf"
                download="labels.pdf"
              />
            </div>
          </div>
        </v-col>
      </v-row>
    </main>
  </div>
</template>

<script>
export default {
  name: 'LabelPrinting',

  data() {
    return {
      template: null,
      labelTemplates: [],
      templateListSearch: '',
      file: null,
      pdf: null,
      loading: false,
      loadingLabels: false,
      labelType: 'label',
    };
  },

  created() {
    this.loadLabelTemplates();
  },

  methods: {
    async loadLabelTemplates() {
      try {
        this.loading = true;
        const { data: labelTemplates } = await this.$http.get('/labels/types');
        this.labelTemplates = labelTemplates;
        if (labelTemplates[0]) {
          this.template = labelTemplates[0]; // eslint-disable-line
        }
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },

    async downloadTemplate() {
      this.loading = true;
      try {
        // const { data } = await this.$http.get(`/asn/asn-template.xlsx?label=${this.labelType}`, {
        //   headers: {
        //     'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        //   },
        //   responseType: 'blob',
        // });
        const { data } = await this.$http.get(`/asn/asn-template.xlsx?label=true`, {
          headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
          responseType: 'blob',
        });
        this.template = URL.createObjectURL(data);
        await this.$nextTick();
        this.$refs.template.click();
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },

    selectFile() {
      if (this.$refs.file) {
        this.$refs.file.value = null;
        this.$refs.file.click();
      }
    },

    setFile() {
      [this.file] = this.$refs.file.files;
    },

    async createLabels() {
      this.loading = true;
      try {
        const fileData = await this.getFileData(this.file);
        // const { data } = await this.$http.post(`/labels/get-label/${this.labelType}`, fileData, {
        //   headers: {
        //     'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        //   },
        //   responseType: 'blob',
        // });
        const { data } = await this.$http.post(`/labels/label`, fileData, {
          headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
          responseType: 'blob',
        });
        
        if (data) {
          this.pdf = URL.createObjectURL(data);
          await this.$nextTick();
          this.$refs.pdf.click();
        }
      } finally {
        this.loading = false;
        if (this.$refs.file) {
          this.$refs.file.value = null;
        }
        this.file = null;
      }
    },

    getFileData(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.readAsArrayBuffer(file);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.labels-page {
  .step {
    min-height: 280px;
  }

  .step__top__description {
    color: var(--topaz);
  }

  .step_first__buttons__button {
    padding: 12px 25px;

    i {
      font-size: 16px;
    }

    &:hover {
      i {
        color: var(--aurum);
      }
    }

    &_download {
      color: var(--aurum);

      i {
        color: var(--aurum);
      }

      &:hover {
        color: var(--margaritas);

        i {
          color: var(--margaritas);
        }
      }
    }
  }

  .step_first__selected {
    height: 50px;
    margin-top: 30px;

    &-label {
      color: var(--platinum);
    }

    &-filename {
      color: var(--topaz)
    }
  }

  .step_second__buttons__button {
    padding: 12px 25px;
  }
}
</style>
